/**
 * Decides whether a connector row renders as toggled on in the sources dropdown.
 *
 * An empty selection with org knowledge on means "all connected apps apply" (see
 * `getAppFilters`), so every connected app must read as on — otherwise a freshly
 * connected app would show off even though it is included in the next
 * message. A non-empty selection is an explicit narrowed set, so only the listed
 * apps are on. This mirrors the initial-load `shouldSelectAll` behaviour and is
 * shared by the init and both re-init paths so they cannot drift.
 */
export const isAppSelected = (
	app: { source: string; isUserOAuthed?: boolean },
	preservedSelectedApps: { source: string }[],
	orgKnowledgeEnabled?: boolean,
): boolean => {
	const shouldSelectAll = preservedSelectedApps.length === 0 && orgKnowledgeEnabled !== false;
	return shouldSelectAll
		? !!app.isUserOAuthed
		: preservedSelectedApps.some((a) => a.source === app.source);
};
